<i18n src="@/i18n/components/event-invite-link.json"></i18n>

<template>
  <section class="hero is-primary" style="background-color: #42a5f5">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="columns is-mobile">
          <div class="column is-half-tablet is-offset-one-quarter-tablet">
            <h1 class="title is-4" style="font-weight: bold">
              {{ $t('invitePeople') }}
            </h1>
            <h2 class="subtitle is-6" style="font-weight: 400">
              {{ $t('copyAndShare') }}
            </h2>

            <div class="field has-addons">
              <p class="control is-expanded has-icons-left">
                <input id="event-link" class="input" :value="baseUrl + '/event/' + eventId" readonly>
                <span class="icon is-small is-left"><i class="fa fa-external-link"></i></span>
              </p>
              <p class="control">
                <a class="button is-info" ref="copy-event-link-button" data-clipboard-target="#event-link">
                  {{ $t('copy') }}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import Clipboard from 'clipboard'

  const location = window.location

  export default {
    name: 'event-invite-link',
    props: ['event-id'],
    mounted () {
      let clipboard = new Clipboard(this.$refs['copy-event-link-button'])
      clipboard.on('success', () => {
        this.$toast.open({
          message: this.$t('linkCopied'),
          position: 'is-bottom',
          type: 'is-info'
        })
      })
    },
    data () {
      return {
        baseUrl: location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/EventInviteLink.vue